import React, { useState, useEffect } from 'react';
import { View, Text, TextInput, TouchableOpacity, Image, ActivityIndicator } from 'react-native';
import { Checkbox } from 'react-native-paper';
import { LinearGradient } from "expo-linear-gradient";

import HeaderDefault from '../../components/HeaderDefault';

import styles from "./styles";

const BuyToken = ({ navigation, route }) => {
    const [checked, setChecked] = useState(false);
    const [qtd, setQtd] = useState();
    const [token, setToken] = useState({
        actives: [{
            active: true,
            amount_token: 0,
            blockchain_id: "",
            category: 0,
            client_id: 0,
            created_at: "",
            deadline_token: "",
            description: "",
            file_id: 0,
            final_letra: 0,
            final_linha: 0,
            id: 0,
            mime_type: "",
            min_value_token: 0.00,
            name: "",
            name_token: "",
            path: "",
            single_value: 0,
            size: 0,
            total_lote: 0,
            total_value_token: 0.00,
            type_value: "",
            updated_at: ""
        }],
        "files_actives": [],
        "tokens": [],
    });
    const [valueCoin, setValueCoin] = useState(0);

    useEffect(() => {
        setToken(route.params.token);
        setQtd(JSON.stringify(route.params.qtd));
        //console.log(route.params.token)
    }, []);

    return (
        <>
            <HeaderDefault title={"CONFIRMAR COMPRA"} />
            <View style={styles.content}>
                <View style={styles.token_header_container}>
                    <Image source={{ uri: token.actives !== undefined ? `https://filesgpx.s3.us-east-2.amazonaws.com/${token.actives[0].path}` : '' }} style={styles.token_header_image} />
                    <Text style={styles.token_header_title}>{token.actives[0].name_token ? token.actives[0].name_token : "GPX"}</Text>
                </View>
                <View style={styles.contentAmount}>
                    <Text style={styles.titlePage}>Quantidade:</Text>
                    <Text style={styles.textInputAmount}>{qtd}</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}> Último preço:</Text>
                    <Text style={styles.price}>000.000,00GPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                        Preço de venda:
                    </Text>
                    <Text style={styles.price}>{token ? token.single_value : "000.000,00"}GPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                        Preço de mercado:
                    </Text>
                    <Text style={styles.price}>000.000,00GPX</Text>
                </View>
            </View>

            <View style={styles.contentCheckbox}>
                <Checkbox
                    status={checked ? 'checked' : 'indeterminate'}
                    onPress={() => {
                        setChecked(!checked);

                    }}
                />
                <Text>Comprar a preço de mercado</Text>
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={() => navigation.navigate('ConfirmPassword', { qtd: qtd, valueCoin: valueCoin, market: checked, purchase: true })}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>CONTINUAR</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default BuyToken;